import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import RadarIcon from '@mui/icons-material/Radar';

const LoadingScreen = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', bgcolor: '#074960', gap: 2 }}>
        <RadarIcon sx={{ color: '#fff', fontSize: 48 }} />
        <Typography variant="h5" color="white" fontWeight={700}>Compras Radar</Typography>
        <CircularProgress sx={{ color: '#fff' }} />
    </Box>
);

export default LoadingScreen;
